// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/attention.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
/**
 * @generated from message mono.datagateway.v1.AttentionItem
 */ export class AttentionItem extends Message {
    static fromBinary(bytes, options) {
        return new AttentionItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AttentionItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AttentionItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AttentionItem, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string notification_type = 2;
   */ _define_property(this, "notificationType", ""), /**
   * @generated from field: string source_type = 3;
   */ _define_property(this, "sourceType", ""), /**
   * @generated from field: string source_id = 4;
   */ _define_property(this, "sourceId", ""), /**
   * @generated from field: string title = 5;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string body = 6;
   */ _define_property(this, "body", ""), /**
   * @generated from field: string severity = 7;
   */ _define_property(this, "severity", ""), /**
   * @generated from field: string program_id = 8;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AttentionItem, "runtime", proto3);
_define_property(AttentionItem, "typeName", "mono.datagateway.v1.AttentionItem");
_define_property(AttentionItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "notification_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "body",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "severity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListAttentionRequest
 */ export class ListAttentionRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListAttentionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListAttentionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListAttentionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListAttentionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * 0 = all permitted
   *
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListAttentionRequest, "runtime", proto3);
_define_property(ListAttentionRequest, "typeName", "mono.datagateway.v1.ListAttentionRequest");
_define_property(ListAttentionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListAttentionResponse
 */ export class ListAttentionResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListAttentionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListAttentionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListAttentionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListAttentionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.AttentionItem items = 1;
   */ _define_property(this, "items", []), /**
   * total counts only permitted open items (the pending-review dimension).
   *
   * @generated from field: int32 total = 2;
   */ _define_property(this, "total", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListAttentionResponse, "runtime", proto3);
_define_property(ListAttentionResponse, "typeName", "mono.datagateway.v1.ListAttentionResponse");
_define_property(ListAttentionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "items",
            kind: "message",
            T: AttentionItem,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ResolveAttentionRequest
 */ export class ResolveAttentionRequest extends Message {
    static fromBinary(bytes, options) {
        return new ResolveAttentionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveAttentionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveAttentionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveAttentionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string id = 3;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveAttentionRequest, "runtime", proto3);
_define_property(ResolveAttentionRequest, "typeName", "mono.datagateway.v1.ResolveAttentionRequest");
_define_property(ResolveAttentionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ResolveAttentionResponse
 */ export class ResolveAttentionResponse extends Message {
    static fromBinary(bytes, options) {
        return new ResolveAttentionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveAttentionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveAttentionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveAttentionResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveAttentionResponse, "runtime", proto3);
_define_property(ResolveAttentionResponse, "typeName", "mono.datagateway.v1.ResolveAttentionResponse");
_define_property(ResolveAttentionResponse, "fields", proto3.util.newFieldList(()=>[]));
